import React from 'react';
import { TextBody } from '@ally/metronome-ui';
import MenuLink from './MenuLink';
import { AccordionMenuItem, StyledSubMenuList } from './StyledMenuComponents';
import { StyledAccordionWrapper } from './AccordionSubMenu';
import { useFeatureFlags } from '../FeatureFlagContext';
import { useAccordionClose } from './useAccordionClose';
const ChecksDebitCardsMenuContent = ({ accordionId, routeInEmber, routeLinks, closeMenu, activeAccordion, updateAccordionState, }) => {
    const featureFlags = useFeatureFlags();
    const { isManageDebitCardEnabled, isReplaceDebitCardEnabled } = featureFlags;
    useAccordionClose({
        accordionId,
        activeAccordion,
        updateAccordionState,
    });
    return (React.createElement(StyledSubMenuList, { "aria-label": "Checks and Debit Cards" },
        React.createElement(AccordionMenuItem, null,
            React.createElement(TextBody, { tag: "span", size: "sm", tabIndex: -1 },
                React.createElement(MenuLink, { to: routeLinks.orderChecks.bankUrl, text: routeLinks.orderChecks.content, routeInEmber: routeInEmber, closeMenu: closeMenu, withAllyTM: "orderChecks-profileSettings" }))),
        React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.orderDebitCard.bankUrl, text: routeLinks.orderDebitCard.content, routeInEmber: routeInEmber, closeMenu: closeMenu, withAllyTM: "orderDebitCard-profileSettings" })),
        isManageDebitCardEnabled && (React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.manageDebitCard.bankUrl, text: routeLinks.manageDebitCard.content, routeInEmber: routeInEmber, closeMenu: closeMenu, withAllyTM: "manageDebitCard-profileSettings" }))),
        isReplaceDebitCardEnabled && (React.createElement(AccordionMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.replaceDebitCard.bankUrl, text: routeLinks.replaceDebitCard.content, routeInEmber: routeInEmber, closeMenu: closeMenu, withAllyTM: "replaceDebitCard-profileSettings" })))));
};
export default function ChecksDebitCardsMenu({ hasDebitCardEligibleAccounts, routeInEmber, routeLinks, bankStatus, closeMenu, closeAccordion, activeAccordion, updateAccordionState, }) {
    const featureFlags = useFeatureFlags();
    const { isOrderDebitCardEnabled } = featureFlags;
    const showMenu = isOrderDebitCardEnabled && hasDebitCardEligibleAccounts;
    if (!showMenu) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(StyledAccordionWrapper, { key: "checks-debit-cards-submenu", disableContainer: true, items: [
            {
                heading: 'Checks and Debit Cards',
                panel: (React.createElement(ChecksDebitCardsMenuContent, { accordionId: "checks-debit-cards", routeInEmber: routeInEmber, routeLinks: routeLinks, bankStatus: bankStatus, closeMenu: closeMenu, closeAccordion: closeAccordion, activeAccordion: activeAccordion, updateAccordionState: updateAccordionState })),
            },
        ] }));
}
//# sourceMappingURL=ChecksDebitCardsMenu.js.map